import {
  NAMESPACE,
  DATEFILTER_SET_LAST_ONES_OPTION,
  DATEFILTER_SET_DATE,
  DATEFILTER_SET_TAB,
} from './consts';

function setLastOnesOption(view, id, option) {
  return {
    namespace: NAMESPACE,
    type: DATEFILTER_SET_LAST_ONES_OPTION,
    view,
    id,
    option,
  };
}

function setTab(view, id, tab) {
  return {
    namespace: NAMESPACE,
    type: DATEFILTER_SET_TAB,
    view,
    tab,
    id,
  };
}

function setDate(view, id, date, endDate) {
  return {
    namespace: NAMESPACE,
    type: DATEFILTER_SET_DATE,
    view,
    id,
    date,
    endDate,
  };
}

const actions = {
  setLastOnesOption,
  setDate,
  setTab,
};

export default actions;
